import { parsePhoneNumber, CountryCode } from 'libphonenumber-js';

import { PhoneValidationError } from '../models/validation-errors.model';

/**
 * Validates an international phone number with reason-specific error codes.
 * Uses libphonenumber-js for accurate international format validation.
 * @param value - Phone number string
 * @param defaultCountry - Default country code if number doesn't have + prefix (default: 'BR')
 * @returns ValidationErrors with reason code or null if valid
 */
export function validatePhone(
  value: string,
  defaultCountry: CountryCode = 'BR',
): PhoneValidationError | null {
  if (!value) return null;

  const cleaned = value.trim();

  // Skip validation for very short values (user still typing)
  if (cleaned.length < 8) {
    return null;
  }

  try {
    const phoneNumber = parsePhoneNumber(cleaned, defaultCountry);

    if (!phoneNumber) {
      return { phone: { reason: 'unparseable' } };
    }

    if (!phoneNumber.isValid()) {
      return {
        phone: {
          reason: 'invalid',
          country: phoneNumber.country,
        },
      };
    }

    return null;
  } catch {
    return { phone: { reason: 'unparseable' } };
  }
}

// Re-export CountryCode for consumers who need to specify country
export { CountryCode };
